var APP = APP || {};

APP.pushGaEvent = function (category, action, label) {
    if (typeof (ga) === 'function') {
        ga('send', 'event', category, action, label);
    }
};

APP.fbShare = function (image, message) {
    if (!image) {
        image = APP.baseUrl;
    }
    
    image = image.split('?')[0];
    
    FB.ui({
        method: 'share',
        quote: message,
        href: APP.baseUrl,
        picture: image
    }, function (response) {
        APP.pushGaEvent('share', 'share facebook', 'Facebook Share');
    });
};

APP.twShare = function (link, message) {
    if (!link) {
        link = APP.baseUrl;
    }
    if (!message) {
        message = encodeURIComponent(APP.shareCopy);
    }
    
    APP.pushGaEvent('share', 'share twitter', 'Twitter Share');
    
    window.open('https://twitter.com/share?text=' + message + '&url=' + link, 'twitterwindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
};

$(document).ready(function(e) {
	var mosiacHt = $('.gallery .img-gall').innerWidth() * 0.73;
	$('.gallery .img-gall').css('height', mosiacHt);
	
    $('.individual-post').on('click', function(){
        var imageUrl = $(this).css('background-image');
        imageUrl = imageUrl.replace('url(','').replace(')','').replace(/\"/gi, "");
        imageUrl = imageUrl.replace(':thumb','');

        var userName = $(this).data('username');
        var userComment = $(this).data('usercomment');

        $.colorbox({
                href: '#gal-pop',
                inline: true,
                width: '96%',
                maxWidth: '520',
                onComplete: function(){
                    $('#galleryImg').attr('src', '');
                    $('#galleryImg').attr('src', imageUrl);

                    $('h4#userName').text(userName);
                    $('p#userComment').text(userComment);

                    FB.XFBML.parse(document.getElementById('fbShare'));

                    $('.fbShare').on('click',function(e){
                        e.preventDefault();
                        var message = "Check out @" + userName + "’s entry into the Water Babies #grumpybabies contest at http://www.grumpybabies.co.uk/";
                        
                        APP.fbShare(imageUrl, message);
                    });
                    
                    $('.twShare').on('click',function(e){
                        e.preventDefault();
                        
                        APP.twShare('http://bit.ly/2ek4X7r', "Check out %40" + userName + "’s entry into the Water Babies %23grumpybabies contest");
                    });
                    
                    setTimeout(function(){
                        $.colorbox.resize();
                    }, 800);
                }
        });
    });
	
    $('.show-popup').colorbox({
        inline: true, width: '90%', maxWidth: '700', onComplete: function () {
            $('#cboxContent').addClass('bottomMargin');
        }
    });
});

